import styled from 'styled-components';

export const StyledErrorListContainer = styled.div`
    > div:not(:last-of-type) {
        padding-bottom: 10px;
    }
`;
